window.onload = function () {
    // La je cible les événements sur les <ul> plutot que les <button> par soucis de bestPractice
    // IL faut mieux initier le moins d'écoute d'événements possible 
    // Pour ça on cible un container et on controle ensuite quel élément de ce container à été cliqué
    var allButtonList = document.querySelectorAll(".order-details-action-list")

    for (var i = 0; i < allButtonList.length; i++) {
        allButtonList[i].addEventListener("click", function (event) {
            if (event.target.classList.contains("mpi-action-btn")) {
                var targetAction = event.target.dataset.target;
                var targetDiv = this.querySelector("." + targetAction);
                var elemData = event.target.dataset;

                if (elemData.load === "false") {   // Si on a pas encore récuperer le contenu du formulaire via Ajax
                    switch (targetAction) {
                        case "receiveConfirm":
                            receiveConfirm(targetAction, { PacketId: elemData.packetId, SellerId: elemData.sellerId, SellerName: elemData.sellerName });
                            break;
                        case "rateSeller":
                            rateSeller(targetAction, { PacketId: elemData.packetId, SellerId: elemData.sellerId, SellerName: elemData.sellerName });
                            break;
                        case "contactSeller":
                            contactSeller(targetAction, { PacketId: elemData.packetId, SellerId: elemData.sellerId, Confirmation: false  });
                            break;
                        case "openIncident":
                            openIncident(targetAction, { ItemId: elemData.itemId, LineId: elemData.lineId, PacketId: elemData.packetId, IsReceived: elemData.isReceived });
                            break;
                        case "closeIncident":
                            closeIncident(targetAction, { ItemId: elemData.itemId, LineId: elemData.lineId, PacketId: elemData.packetId, IsReceived: elemData.isReceived });
                            break;
                        /*case "showMessages":
                            showMessages(targetAction, { PacketId: elemData.packetId, SellerId: elemData.sellerId });
                            break;*/
                    }
                    targetDiv.style.display = "block"
                    event.target.classList.add("active");

                }
                else {
                    if (targetDiv.style.display === "none") {   // Sinon on vérifie juste si il faut afficher ou masque le formulaire
                        targetDiv.style.display = "block"
                        event.target.classList.add("active");
                    }
                    else {
                        targetDiv.style.display = "none";
                        event.target.classList.remove("active");
                    }
                }
            }
        });
    }
};

//////////////// AJAX POUR AFFICHER LES FORMULAIRES /////////// 
function receiveConfirm(target, param) {
    var targetDiv = document.querySelector("#" + target + "Result" + param.SellerId);
    var button = document.querySelector("#" + target + "Button" + param.SellerId);

    $.ajax({
        cache: false,
        type: 'GET',
        url: "/EspaceClient/GetReceiveConfirmForm",
        data: {
            orderId: param.PacketId,
            sellerId: param.SellerId,
            sellerName: param.SellerName
        },

        success: function (data) {
            targetDiv.innerHTML = data.Result;
            button.dataset.load = "true";
        },
        beforeSend: function () {
            Foundation.libs.common.showPreloader();
        },
        complete: function () {
            Foundation.libs.common.hidePreloader();
        }
    });
}

function getRateSellerButton(param) {
    var targetDiv = document.querySelector("#rateSeller" + param.SellerId);

    $.ajax({
        cache: false,
        type: 'GET',
        url: "/EspaceClient/GetRatingButton",
        data: {
            orderId: param.PacketId,
            sellerId: param.SellerId,
            sellerName: param.SellerName
        },

        success: function (data) {
            targetDiv.innerHTML = data.Result;
            if (param.RateSeller) {
                rateSeller("rateSeller", { PacketId: param.PacketId, SellerId: param.SellerId, SellerName: param.SellerName });
            }
        },
        beforeSend: function () {
            Foundation.libs.common.showPreloader();
        },
        complete: function () {
            Foundation.libs.common.hidePreloader();
        }
    });
}

function rateSeller(target, param) {
    var targetDiv = document.querySelector("#rateSellerResult" + param.SellerId);
    var button = document.querySelector("#" + target + "Button" + param.SellerId);

    $.ajax({
        cache: false,
        type: 'GET',
        url: "/EspaceClient/GetRatingTypeList",
        data: {
            orderId: param.PacketId,
            sellerId: param.SellerId,
            sellerName: param.SellerName
        },

        success: function (data) {
            targetDiv.innerHTML = data.Result;
            rateSellerEvent(targetDiv);
            if (button != undefined) {
                button.dataset.load = "true";
            }
        },
        beforeSend: function () {
            Foundation.libs.common.showPreloader();
        },
        complete: function () {
            Foundation.libs.common.hidePreloader();
        }
    });
}

function contactSeller(target, param) {
    var targetDiv = document.querySelector("#"+ target +"Result" + param.SellerId);
    var button = document.querySelector("#" + target + "Button" + param.SellerId);

    $.ajax({
        cache: false,
        type: 'GET',
        url: "/EspaceClient/GetMessageReasons",
        data: {
            sellerId: param.SellerId,
            packetId: param.PacketId
        },

        success: function (data) {
            targetDiv.innerHTML = data.Result;
            var messagesTargetDiv = document.querySelector("#messages-" + param.SellerId);
            var messages = data.Messages;

            while (messages.includes("&lt;") || messages.includes("&gt;")) {   
                messages = messages.replace("&lt;", "<");
                messages = messages.replace("&gt;", ">");
            }

            messagesTargetDiv.innerHTML = messages;
            button.dataset.load = "true";
        },
        beforeSend: function () {
            Foundation.libs.common.showPreloader();
        },
        complete: function () {
            Foundation.libs.common.hidePreloader();
            if (param.Confirmation)
                document.querySelector("#sendConfirm" + param.SellerId).innerHTML = "<span>Votre message a bien été envoyé, vous recevrez une réponse dans les meilleurs délais.</span>";
        }
    });
}


function openIncident(target, param) {
    var targetDiv = document.querySelector("#incidentResult" + param.ItemId);
    var button = document.querySelector("#incidentButton" + param.ItemId);
    var messageResultDiv = document.querySelector("#incidentValidationMessage" + param.ItemId);

    $.ajax({
        cache: false,
        type: 'GET',
        url: "/EspaceClient/GetIncidentReasons",
        data: {
            itemId: param.ItemId,
            lineId: param.LineId,
            packetId: param.PacketId,
            isReceived: param.IsReceived.toLowerCase()==="true"?true:false
        },

        success: function (data) {
            messageResultDiv.innerHTML = "";
            targetDiv.innerHTML = data.Result;
            button.dataset.load = "true";
        },
        beforeSend: function () {
            Foundation.libs.common.showPreloader();
        },
        complete: function () {
            Foundation.libs.common.hidePreloader();
        }
    });
}

function closeIncident(target, param) {
    var targetDiv = document.querySelector("#incidentResult" + param.ItemId);
    var button = document.querySelector("#incidentButton" + param.ItemId);
    var messageResultDiv = document.querySelector("#incidentValidationMessage" + param.ItemId);

    $.ajax({
        cache: false,
        type: 'GET',
        url: "/EspaceClient/GetCloseIncidentReasons",
        data: {
            itemId: param.ItemId,
            lineId: param.LineId,
            packetId: param.PacketId,
            isReceived: param.IsReceived.toLowerCase() === "true" ? true : false
        },

        success: function (data) {
            messageResultDiv.innerHTML = "";
            targetDiv.innerHTML = data.Result;
            button.dataset.load = "true";
        },
        beforeSend: function () {
            Foundation.libs.common.showPreloader();
        },
        complete: function () {
            Foundation.libs.common.hidePreloader();
        }
    });
}

function showMessages(target, param) {
    var targetDiv = document.querySelector("#" + target + "Result" + param.SellerId);
    var button = document.querySelector("#" + target + "Button" + param.SellerId);

    $.ajax({
        cache: false,
        type: 'GET',
        url: "/EspaceClient/GetOrderMessages",
        data: {
            packetId: param.PacketId
        },

        success: function (data) {
            cleanResult(param.SellerId);
            targetDiv.innerHTML = data.Result;
            button.dataset.load = "true";
        },
        beforeSend: function () {
            Foundation.libs.common.showPreloader();
        },
        complete: function () {
            Foundation.libs.common.hidePreloader();
        }
    });
}

//////////////////////////// AJAX POUR ENVOYER LES FORMULAIRES ////////////////////
function OnSetReceiveConfirm(data) {
    var targetDiv = document.querySelector("#receiveConfirm" + data.SellerId);
    var targetDivResult = document.querySelector("#result" + data.SellerId);

    if (data.IsValid) {
        cleanResult(data.SellerId);
        targetDiv.innerHTML = data.Partial;
        targetDivResult.innerHTML = data.Message;
        updateIncidentButtonStatus(data.OrderId);
        getRateSellerButton({ PacketId: data.OrderId, SellerId: data.SellerId, SellerName: data.SellerName, RateSeller: data.RateSeller });
    }
    else {
        targetDiv.innerHTML = "<span>" + data.Result + "</span>";
    }
}

function OnSetSellerRate(data) {
    var targetDiv = document.querySelector("#rateSeller" + data.SellerId);
    
    if (data.IsValid) {
        cleanResult(data.SellerId);
        targetDiv.innerHTML = data.Partial; // Pour que les boutons disponibles sur cette action se mettent à jour (typiquement ici, une fois que le client aura noté le vendeur, le bouton n'apparaitra plus)
        var targetDivResultMessage = document.querySelector("#result" + data.SellerId);
        targetDivResultMessage.innerHTML = "<span>" + data.Message + "</span>"; 
    }
    else {
        var targetDivResult = document.querySelector("#rateSellerResult" + data.SellerId);
        targetDivResult.innerHTML = data.Result;
        rateSellerEvent(targetDivResult);
    }
}

function OnSetSellerMessage(data) {
    if (data.IsValid) {
        contactSeller("contactSeller", { SellerId: data.SellerId, PacketId: data.PacketId, Confirmation: true });
    }
    else {
        var targetDivResult = document.querySelector("#contactSellerResult" + data.SellerId);
        targetDivResult.innerHTML = data.Result;
        var messagesTargetDiv = document.querySelector("#messages-" + data.SellerId);
        messagesTargetDiv.innerHTML = data.Messages;
    }
}

function OnSetIncident(data) {
    var targetDiv = document.querySelector("#incident" + data.ItemId);

    if (data.IsValid) {
        targetDiv.innerHTML = data.Partial;
        setTimeout(function () {    // Vu que tout les éléments ci-dessous seront créé grâce à la ligne du dessus, il ne faut effectuer ses actions que après que la targetDiv soit remplis
            var targetDivResult = targetDiv.querySelector("#incidentValidationMessage" + data.ItemId);
            targetDivResult.innerHTML = "<span>" + data.Message + "</span>";
        }, 100);
        
    }
    else {
        var targetDivResult = targetDiv.querySelector("#incidentResult" + data.ItemId);
        targetDivResult.innerHTML = data.Result;
        var targetDivMessage = targetDiv.querySelector("#incidentError-" + data.ItemId);
        targetDivMessage.innerHTML = data.Message;
    }
}

function OnSetIncidentClose(data) {
    var targetDiv = document.querySelector("#incident" + data.ItemId);

    if (data.IsValid) {
        targetDiv.innerHTML = data.Partial;
        setTimeout(function () {
            var targetDivResult = targetDiv.querySelector("#incidentValidationMessage" + data.ItemId);
            targetDivResult.innerHTML = "<span>" + data.Message + "</span>";
        }, 100);
    }
    else {
        var targetDivResult = targetDiv.querySelector("#incidentResult" + data.ItemId);
        targetDivResult.innerHTML = data.Result;
    }
}

/////////////////////// FONCTIONS AUTRES /////////////////////


// Fonction pour assigner la valeur de la note choisi à l'input du formulaire
function rateSellerEvent(targetDiv) {   
    var allRatingList = targetDiv.querySelectorAll(".rating-marks-list");  // les containers des notes disponibles
    var selectStars = function (target) { // selectionner les stars visuellement
        target.classList.add("active");
        var prev = target;
        var next = target;
        while (prev = prev.previousElementSibling) {
            prev.classList.add("active")
        }
        while (next = next.nextElementSibling) {
            next.classList.remove("active")
        }   
    }
    for (var i = 0; i < allRatingList.length; i++) {
        
       
        allRatingList[i].addEventListener("click", function (event) {
            var ratingList = this;
            var messageContainer = ratingList.nextElementSibling;
            if (event.target.classList.contains("rating-mark-value")) { // Si le clique se fait sur une des notes
                var selectMark = event.target;    // La note choisi
                var value = selectMark.dataset.mark;
                
                var ratingInput = selectMark.parentElement.querySelector(".rating-input");     // L'input qui enverra la note
                ratingInput.value = parseInt(value);   // On assigne à l'input la valeur de la note choisi
                selectStars(selectMark); // On selectionne tous les stars avant 

                switch (value) {
                    case "1":
                        messageContainer.textContent = "Très Mécontent";
                        break;
                    case "2":
                        messageContainer.textContent = "Mécontent";
                        break;
                    case "3":
                        messageContainer.textContent = "Passable";
                        break;
                    case "4":
                        messageContainer.textContent = "Satisfait";
                        break;
                    case "5":
                        messageContainer.textContent = "Très satisfait";
                        break;

                } 
            }
        });
    }
}

// Fonction qui effacera le message de confirmation
// Utile lorsque l'on effectue une autre action dont le résultat ne sera pas dans cette div 
function cleanResult(sellerId) {
    var globalResult = document.querySelector("#result" + sellerId);
    var contactResult = document.querySelector("#contactSellerResult" + sellerId);
    var rateResult = document.querySelector("#rateSellerResult" + sellerId);
    var contactButton = document.querySelector("#contactSellerButton" + sellerId);
    var receiveButton = document.querySelector("#receiveConfirmButton" + sellerId);
    var rateButton = document.querySelector("#rateSellerButton" + sellerId);

    if (globalResult != undefined)
        globalResult.innerHTML = "";

    if (contactResult != undefined)
        contactResult.innerHTML = "";

    if (rateResult != undefined)
        rateResult.innerHTML = "";

    if (contactButton != undefined)
        contactButton.dataset.load = false;

    if (receiveButton != undefined)
        receiveButton.dataset.load = false;

    if (rateButton != undefined)
        rateButton.dataset.load = false;
}

function updateIncidentButtonStatus(packetId) {
    var allIncidentButton = document.querySelectorAll(".incidentButton" + packetId);

    for (var i = 0; i < allIncidentButton.length; i++) {
        allIncidentButton[i].dataset.isReceived = true;
    }
}
